import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { preInitApp } from '@eui/core';
import { Amplify } from 'aws-amplify';
import { awsconfig } from './aws-exports';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

Amplify.configure(awsconfig);

if (environment.production) {
  enableProdMode();
}

preInitApp(environment).then(() =>
  bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err))
);
